import React, { useState } from "react";
import { Container, Row } from "reactstrap";
import { useLocation } from "react-router-dom"; // Import useLocation
import { ReactComponent as HomeIcon } from "../../assets/img/home.svg";
import { ReactComponent as User } from "../../assets/img/user.svg";
import { ReactComponent as Notification } from "../../assets/img/notification-02.svg";
import { ReactComponent as Transactions } from "../../assets/img/Graph.svg";
import AuthService from "services/auth.service";

function MobileFooter() {
  const location = useLocation(); // Get the current location
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  // Function to check if the route is active
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active-mob" : "";
  };

  const logOut = () => {
    AuthService.logout();

    setShowAdminBoard(false);
    setCurrentUser(undefined);
  };

  return (
    <footer>
      <Container>
        <Row>
          <div className="navbar-mob">
            <a
              href="/user/dashboard"
              className={`nav-item-mob ${activeRoute("/user/dashboard")}`}
            >
              <HomeIcon />
            </a>
            <a
              href="/user/tables"
              className={`nav-item-mob ${activeRoute("/user/tables")}`}
            >
              <Transactions />
            </a>
            <a
              href="/user/notifications"
              className={`nav-item-mob ${activeRoute("/user/notifications")}`}
            >
              <Notification />
            </a>
            <a
              href="/user/user-page"
              className={`nav-item-mob ${activeRoute("/user/user-page")}`}
            >
              <User />
            </a>
            <a href="/" onClick={logOut}>
              <i
                className="fa-solid fa-arrow-right-from-bracket nav-item-mob"
                style={{ width: "24px", height: "24px", color: "red" }}
              ></i>
            </a>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default MobileFooter;
